import { createContext } from '@lit/context';
import { AiSmartSearchClient } from '../clients/ai-smart-search-client';

export const aiSmartSearchClientContext = createContext<AiSmartSearchClient>(Symbol('ai-smart-search-client-context'));
